import { useState } from 'react'
import { Form } from 'antd'

const useActivityModal = () => {
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [form] = Form.useForm()

  const showModal = () => {
    setIsModalVisible(true)
  }

  const handleCancel = () => {
    setIsModalVisible(false)
    form.resetFields()
  }

  const handleAdd = () => {
    form
      .validateFields()
      .then((values) => {
        // In a real application, this would add the new activity to the database
        setIsModalVisible(false)
        form.resetFields()
      })
      .catch((info) => {})
  }

  return {
    isModalVisible,
    form,
    showModal,
    handleCancel,
    handleAdd
  }
}

export default useActivityModal
